<template>
	<validation-provider
			:name="'AdminSelectCriteriumCode-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctCrtrmCd_stateAdminCriteria())"
				item-text="key"
				item-value="key"
				placeholder="Criterium Code"
				@change="$_admnSlctCrtrmCd_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectCriteriumCode',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			$_admnSlctCrtrmCd_stateAdminCriteria() {
				const self_ = this;
				return () => {
					return self_.getAdminState('criteria')
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_admnSlctCrtrmCd_getCriteria()
		},
		methods: {
			$_admnSlctCrtrmCd_getCriteria() {
				const self_ = this;

				let criteria_ = self_.getAdminState('criteria')

				if(!self_.isEmpty(criteria_)) { return }

				Promise.resolve().then(() => {
					return self_.getFirestoreCollection('criteria', {}, 0)
				}).then(result => {
					self_.setAdminState('criteria', result)
				})
			},
			$_admnSlctCrtrmCd_setAdminState() {
				const self_ = this;

				let input_ = self_.getAdminState('input')
				const code_ = input_[self_.inputItemKey]

				if(self_.contentKey == 'updateCriterium') {
					input_.name = self_.adminGetCriterium(code_, 'name')
					input_.description = self_.adminGetCriterium(code_, 'description')
				} else {
					input_.criteriumName = self_.adminGetCriterium(code_, 'name')
				}
				self_.setAdminState('input', input_)
			}
		}
	}
</script>

<style scoped>
</style>
